import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toggle } from 'shared/components/ui/toggle';

import * as Styled from './plan-toggle.style';

export type PlanToggleProps = {
  isAnnual: boolean;
  onChange: (isAnnual: boolean) => void;
  disabled?: boolean;
};

export const PlanToggle: React.FC<PlanToggleProps> = ({
  isAnnual,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    onChange(event.target.checked);

  return (
    <Styled.PlanToggle>
      <Typography variant="subtitle2" component="span">
        {t(
          isAnnual
            ? 'forms.onboarding.premium.billing-toggle.annual'
            : 'forms.onboarding.premium.billing-toggle.monthly',
        )}
      </Typography>
      <Toggle
        id="onboarding-premium-billing-toggle"
        value="annual"
        checked={isAnnual}
        onChange={handleChange}
        disabled={disabled}
      />
    </Styled.PlanToggle>
  );
};
